/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core'
import './App.css';
import factory from 'data'

import Footer from './components/Footer'
import Header from './components/Header'
import Showcase from './components/Showcase'
import ZStack from './components/ZStack'
import bubbleCursor from 'bubble_cursor'

class App extends React.Component {
    componentDidMount() {
        new bubbleCursor()
    }

    render() {
        return (
            <ZStack>
                <Header />
                <div>
                    <Showcase factory={factory} />
                    <Footer />
                </div>
            </ZStack>
        )
    }
}



export default App;
